module.exports = __webpack_public_path__ + "img/wm_pic.2703703e.png";